import React from "react";
import Button from "../../utility/ui-components/button";
import home from "../../../common/assets/data/home";
import Section from "../../utility/ui-components/section";
import Container from "../../utility/ui-components/container";

const PageNotFound = () => {
  const data = home.ErrorPage;
  window.scrollTo(0 , 0);
  return (
    <Section>
      <Container>
        <div class="lg:grid lg:grid-cols-2 items-center gap-4">
          <div class="">
            <h1 class="my-2 font-bold text-3xl">{data.heading}</h1>
            <p class="my-2 ">{data.paragraph}</p>
            {data.buttons.map((button, index) => (
              <Button key={index + 1} button={button} />
            ))}
          </div>
          <div>
            <img src={data.file} />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default PageNotFound;
